import { useEffect } from 'react';
import { MediaDispatch, MediaState } from '../domain/media-file.types';
import { loadVideoMetadata } from '../media.helpers';

export const useVideoMetadata = (
  state: MediaState,
  dispatch: MediaDispatch
) => {
  useEffect(() => {
    state.forEach((file) => {
      if (file.type === 'video' && file.url && file.duration === undefined) {
        loadVideoMetadata(file.url)
          .then(({ duration, poster }) => {
            dispatch({
              type: 'MEDIA/VIDEO_METADATA_LOADED',
              id: file.id,
              duration,
              poster,
            });
          })
          .catch(() => {
            dispatch({
              type: 'MEDIA/VIDEO_METADATA_ERROR',
              id: file.id,
            });
          });
      }
    });
  }, [dispatch, state]);
};
